import { render, staticRenderFns } from "./appUpdate.vue?vue&type=template&id=3b2ac4cc&scoped=true&"
import script from "./appUpdate.vue?vue&type=script&lang=js&"
export * from "./appUpdate.vue?vue&type=script&lang=js&"
import style0 from "./appUpdate.vue?vue&type=style&index=0&id=3b2ac4cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ac4cc",
  null
  
)

export default component.exports